import { PAYROLL_FILTERS } from "../types/payrollFiltersTypes";

export interface IPayrollFilters {
  name: string;
  startsWith: string;
  department: string;
  paidBy: string;
  pageSize: number;
  page: number;
  viewCalculated: string | number;
  nameCalculated: string;
  startsWithCalculated: string;
  departmentCalculated: string;
  pageSizeCalculated: number;
  pageCalculated: number;
}

const initialState: IPayrollFilters = {
  name: "firstName",
  startsWith: "all",
  department: "all",
  paidBy: "all",
  pageSize: 100,
  page: 1,
  viewCalculated: "all",
  nameCalculated: "firstName",
  startsWithCalculated: "all",
  departmentCalculated: "all",
  pageSizeCalculated: 100,
  pageCalculated: 1,
};

export const payrollFiltersReducer = (
  state: IPayrollFilters = initialState,
  action: any,
): IPayrollFilters => {
  switch (action.type) {
    case PAYROLL_FILTERS.PAYROLL_FILTERS_SET_SELECTED:
      return {
        ...state,
        ...action.payload,
        // ...state,
        // accountant: action.payload.accountant,
        // client: action.payload.client,
      };
    case PAYROLL_FILTERS.PAYROLL_FILTERS_CLEAR_SELECTED:
      return {
        ...state,
        name: initialState.name,
        startsWith: initialState.startsWith,
        department: initialState.department,
        paidBy: initialState.paidBy,
        pageSize: initialState.pageSize,
        page: initialState.page,
        viewCalculated: initialState.viewCalculated,
        nameCalculated: initialState.nameCalculated,
        startsWithCalculated: initialState.startsWithCalculated,
        departmentCalculated: initialState.departmentCalculated,
        pageSizeCalculated: initialState.pageSizeCalculated,
        pageCalculated: initialState.pageCalculated,
      };
    default:
      return state;
  }
};
